import orderBy from "lodash/orderBy";
import { useTranslation } from "react-i18next";
import moment from "moment";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import ToolTip from "../../../../parts/tooltip";
import { groupExercisesByComplex } from "../../../../utils/complex";
import EditorSessionTable from "./EditorSessionTable";

const ReadOnlyWeekColumn = (props) => {
  const { week, cycle, program, column } = props;
  const { t } = useTranslation("athlete-portal");

  const exerciseListForSession = (session, sessionIndex) => {
    const exerciseList = session?.exercises
      ? props.exercises.filter((ex) => {
          return session.exercises.find((exId) => ex._id === exId);
        })
      : [];
    const groupedExerciseList = groupExercisesByComplex(exerciseList);

    const keyId = `editor_session_table${sessionIndex}_${props.column}`;

    return (
      <EditorSessionTable
        {...props}
        isProgramEditor={true}
        altClass="alt-week-view"
        exerciseList={groupedExerciseList}
        ungroupedExercises={exerciseList}
        sessionIndex={sessionIndex}
        session={session}
        keyId={keyId}
        key={keyId}
        opacity={false}
        workoutOpacityCallback={null}
        exercisesInClipboard={null}
        readOnly={true}
      />
    );
  };

  const sessions = orderBy(week, "order");

  // If there is only one week, the second column will be undefined
  if (!week) return <span />;

  const storeType = cycle.storeType || "programs";
  const notSingleWorkout = storeType !== "single-workout";

  const programToCopy = cycle.programs.find(
    (prog) => program.order + 1 === prog.order
  );
  const hasExercises = programToCopy
    ? programToCopy.sessions.some((session) => session.exercises.length > 0)
    : null;

  return (
    <li className={`week unchecked`} key={`week_column_${column}`}>
      {notSingleWorkout && (
        <header className="min-h-[38.25px]!">
          <div className="flex flex-row items-center justify-between w-full">
            <div className="flex flex-row items-center gap-2">
              <p className="s2 clipped">
                {storeType === "teams"
                  ? `${moment(program.startDate, "YYYYMMDD").format(
                      "MMM D"
                    )} - ${moment(program.startDate, "YYYYMMDD")
                      .add(6, "days")
                      .format("MMM D")}`
                  : t("programs.weekN", { n: sessions[0].week })}
              </p>
              <p>{t("programs.readOnly")}</p>
            </div>

            {storeType === "teams" && (
              <ToolTip
                id={"duplicate-week-teams"}
                body={t("programs.duplicateWeek")}
              >
                <button
                  data-button-type="secondary"
                  onClick={() => {
                    if (!hasExercises) {
                      const dateRange = `${moment(
                        program.startDate,
                        "YYYYMMDD"
                      ).format("MMM D")} - ${moment(
                        program.startDate,
                        "YYYYMMDD"
                      )
                        .add(6, "days")
                        .format("MMM D")}`;
                      if (
                        confirm(
                          t("programs.confirmDuplicateWeekTeams", {
                            dateRange,
                          })
                        )
                      ) {
                        submit(
                          `/actions/cycle/teams-duplicate-week/${cycle._id}`,
                          {
                            method: "POST",
                            body: {
                              program: program.order,
                              clonedProgram: program.order + 1,
                            },
                          }
                        );
                      }
                    } else {
                      alert(t("programs.cannotDuplicateWeekWithExercises"));
                    }
                  }}
                  type="button"
                >
                  <SvgIcon src="/img/new-icons/duplicate.svg" />
                </button>
              </ToolTip>
            )}
          </div>
        </header>
      )}
      <ul className="workouts">{sessions.map(exerciseListForSession)}</ul>
    </li>
  );
};

export default ReadOnlyWeekColumn;
